import React from 'react';
import { useSelector } from 'react-redux';

const Loader = ({ show = false }) => {
  const loading = useSelector(state => state.app.loading);

  return (
    <div>
      {(show || loading) && (
        <div className="loader-overlay">
          <div className="loader" />
        </div>
      )}
    </div>
  );
};

export default Loader;
